import './PreDesign.scss'
import React, {useContext} from 'react';
import { Link } from "react-router-dom";
import { DesignContext } from '../../store/design';
import { TranslationContext } from '../../store/translation';
import Sprite, { getBGStyle } from '../Sprite';


const PreDesign = (props) => {

  const {title, desc, background, items, video, sublabel, bgColor, className, localDesign, carShape } = props;

  const { getText } = useContext(TranslationContext);
  const { setDesign, setInitDesign } = useContext(DesignContext);

  // The edit link is resolved relative to the current URL path (relative="path"), swapping the
  // trailing /predesigns for /edit. Building type, country, product and release are preserved
  // from the current URL. Default route-relative resolution would append to /predesigns and
  // land on a non-matching URL.

  const onClickHandler = (e, design) => {
    setDesign(design)
    setInitDesign(design)
  }

  const themeTileStyle = {
    ...getBGStyle(background)
  }

  return (
    <div className={"PreDesign" + (className ? ' ' + className : '') }>
      <div className="pre-design-container">

        {/* THEME */}
        <div className="pre-design-tile-container">
          <div className="aspect-ratio-1-1">
            <div className="pre-design-tile theme" 
              style={bgColor ? { backgroundColor: bgColor } : themeTileStyle}>
              <h3>{getText(title)}</h3>
              { sublabel && (<h4>{getText(sublabel)}</h4>) }
              { desc &&
                <div className="description">
                  {getText(desc)}
                </div>
              }              
              { video && (
                <a className="readMore" href={video} target="_blank" rel="noopener noreferrer">
                  {getText('ui-general-watch-video')}
                </a>
              ) }
            </div>
          </div>
        </div>
        
        {/* DESIGN */}
        { items && items.map((item, index) => {
          return (
            <div className="pre-design-tile-container" key={index}>
              <div className="aspect-ratio-1-1">
                <Link key={item.sapId} className="pre-design-tile design-item" to={`../edit/${item.sapId}`} relative="path" onClick={ e => onClickHandler(e, item) }>
                    { item.image && item.image.url && (
                      <div className={`sprite-container ${`shape-${item.carShape}`}${localDesign ? ' local-design-container' : ''}`}>
                        <Sprite src={item.image.url} className={`shape-${item.carShape}`} />
                      </div>
                    ) }
                    <span className="label">{getText(item.name)}</span>
                </Link>
              </div>
            </div>
          )
        })}
        
      </div>
    </div>
)}

export default PreDesign;
